import { CommonModule } from '@angular/common'
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute } from '@angular/router'
import { EventService } from '@app/modules/events/services/event.service'
import { DashboardResponse } from '../../models/dashboard.model'
import { ServerRepresentedEvent } from '../../models/event.model'
import { GrossSalesCardComponent } from './analytics-cards/gross-sales-card/gross-sales-card.component'
import { PaymentMethodsCardComponent } from './analytics-cards/payment-methods-card/payment-methods-card.component'
import { SoldProductsCardComponent } from './analytics-cards/sold-products-card/sold-products-card.component'
import { ProductsComponent } from './products/products.component'

@Component({
  selector: 'ngx-financial-dashboard',
  templateUrl: './financial-dashboard.component.html',
  styleUrls: ['./financial-dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, ProductsComponent, GrossSalesCardComponent, SoldProductsCardComponent, PaymentMethodsCardComponent],
  providers: [EventService]
})
export class FinancialDashboardComponent implements OnInit {
  dashboardData: DashboardResponse
  @Input() eventId?: number
  @Input() currencySlug: string
  eventName: string
  private _destroyRef = inject(DestroyRef)

  constructor(private _EventsService: EventService, private _ActivatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.fetchDashboardData()
  }

  fetchDashboardData() {
    const eventId = this.eventId || this._ActivatedRoute.snapshot.params?.eventId
    this._EventsService
      .getEventInfo(eventId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((eventInfo: ServerRepresentedEvent) => {
        if (!eventId) {
          return
        }
        this.eventName = eventInfo.name
        this.currencySlug = eventInfo.currency?.slug
      })
    this._EventsService
      .fetchFinancialDashboardData(eventId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        this.dashboardData = data
      })
  }
}
